import React from 'react';

// Estado de la relación terapéutica del paciente (pacientes.estado_relacion).
// ORTOGONAL a `activo` (soft-delete). Fuente de verdad del vocabulario:
// docs/plan-estado-y-canal-paciente.md §4 + CHECK pacientes_estado_relacion_check.
// Los labels coinciden con RELACION_META de ClinicalRecords.tsx — no divergir.
export type EstadoRelacion = 'activo' | 'en_pausa' | 'alta' | 'desercion' | 'derivado';

const VALID: readonly string[] = ['activo', 'en_pausa', 'alta', 'desercion', 'derivado'];

const META: Record<EstadoRelacion, { label: string; bg: string; color: string }> = {
  activo:    { label: 'En terapia', bg: 'rgba(52, 199, 89, 0.12)', color: 'var(--success-text, #057A55)' },
  en_pausa:  { label: 'En pausa',   bg: 'rgba(255, 149, 0, 0.12)', color: '#C05E00' },
  alta:      { label: 'Alta',       bg: 'rgba(0, 122, 255, 0.12)', color: 'var(--apple-blue)' },
  desercion: { label: 'Deserción',  bg: 'var(--bg-hover, #F0F0F0)', color: 'var(--text-muted)' },
  derivado:  { label: 'Derivado',   bg: 'var(--bg-hover, #F0F0F0)', color: 'var(--text-muted)' },
};

// Estados que el inversor FUNDADOR puede setear desde su portal: sólo
// operativos. `alta` / `derivado` son decisiones clínicas del terapeuta
// (plan §6) y quedan fuera aunque el RPC también las rechaza server-side.
export const ESTADOS_INVERSOR: EstadoRelacion[] = ['activo', 'en_pausa', 'desercion'];

export function normalizeEstadoRelacion(v: unknown): EstadoRelacion {
  return VALID.includes(v as string) ? (v as EstadoRelacion) : 'activo';
}

export function estadoRelacionLabel(v: unknown): string {
  return META[normalizeEstadoRelacion(v)].label;
}

// Badge autónomo (inline styles, sin dependencia de CSS) — se usa tanto en la
// lista (InvestorPatients, estilos inline) como en el detalle (InvestorPatientDetail).
export const RelacionBadge: React.FC<{ estado: unknown }> = ({ estado }) => {
  const m = META[normalizeEstadoRelacion(estado)];
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '4px 10px',
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        background: m.bg,
        color: m.color,
      }}
    >
      {m.label}
    </span>
  );
};
